import React from 'react'
import styles from './LoadingCard.module.css'

const LoadingCard = () => {
  return (
      <div className={styles.loaderPopup}>
        <div className={styles.loaderPopupContainer}>
          <div className={styles.loader}></div>
          <p>
            Redirecting to the payment gateway. Please do not close the next
            window or press back while we confirm your payment status.
          </p>
        </div>
      </div>
    );
}

export default LoadingCard